"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var NormalClose_1 = require("../Icons/NormalClose");
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var PromptErrorFill_1 = require("../Icons/PromptErrorFill");
var PromptInfoCircleFill_1 = require("../Icons/PromptInfoCircleFill");
var CarouselNoticebarList_1 = tslib_1.__importDefault(require("./CarouselNoticebarList"));
var scrollAnimation_1 = require("./scrollAnimation");
var CarouselNoticebar = function (props) {
    var _a = props.type, type = _a === void 0 ? 'info' : _a, _b = props.showIcon, showIcon = _b === void 0 ? true : _b, content = props.content, _c = props.closable, closable = _c === void 0 ? true : _c, closeText = props.closeText, onClose = props.onClose, actionText = props.actionText, className = props.className, onAction = props.onAction, _d = props.withArrow, withArrow = _d === void 0 ? false : _d, arrowLeft = props.arrowLeft, _e = props.global, global = _e === void 0 ? false : _e, style = props.style;
    var _f = tslib_1.__read((0, react_1.useState)(true), 2), visible = _f[0], setVisible = _f[1];
    var _g = tslib_1.__read((0, react_1.useState)(false), 2), isScroll = _g[0], setIsScroll = _g[1];
    var carouselInnerRef = (0, react_1.useRef)(undefined);
    var originScrollWidth = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(function () {
        var inner = carouselInnerRef.current;
        (0, scrollAnimation_1.scrollLoop)(inner, originScrollWidth);
    }, []);
    (0, react_1.useEffect)(function () {
        var dom = carouselInnerRef.current;
        setIsScroll((0, scrollAnimation_1.isOverflow)(dom));
        if ((0, scrollAnimation_1.isOverflow)(dom)) {
            originScrollWidth.current = dom.scrollWidth;
        }
    }, [content]);
    var getIcon = (0, react_1.useCallback)(function () {
        if (!showIcon) {
            return null;
        }
        return {
            info: react_1.default.createElement(PromptInfoCircleFill_1.PromptInfoCircleFill, { className: "anq-notice-icon" }),
            warn: react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "anq-notice-icon" }),
            success: react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { className: "anq-notice-icon" }),
            error: react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "anq-notice-icon" }),
        }[type];
    }, [type, showIcon]);
    var handleClose = (0, react_1.useCallback)(function () {
        setVisible(false);
        onClose && onClose();
    }, []);
    if (!visible) {
        return null;
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)('anq-notice', className, "anq-notice-".concat(global ? 'global-' : '').concat(type), {
            'anq-notice-large': !!global,
        }) },
        withArrow && react_1.default.createElement("div", { className: "anq-notice-arrow-".concat(type), style: { left: arrowLeft } }),
        getIcon(),
        react_1.default.createElement("div", { className: "anq-notice-content", title: typeof content === 'string' ? content : null },
            react_1.default.createElement("div", { className: "anq-notice-content-inner", ref: carouselInnerRef },
                content,
                isScroll && react_1.default.createElement("span", { style: { paddingLeft: 80 } }, content))),
        actionText && (react_1.default.createElement("div", { className: "anq-notice-action", onClick: function () { return onAction && onAction(); } }, actionText)),
        react_1.default.createElement("div", { style: { flexGrow: 1 } }),
        closable &&
            (closeText ? (react_1.default.createElement("div", { className: "anq-notice-close", onClick: handleClose }, closeText)) : (react_1.default.createElement(NormalClose_1.NormalClose, { className: "anq-notice-close-icon", onClick: handleClose })))));
};
CarouselNoticebar.CarouselNoticebarList = CarouselNoticebarList_1.default;
exports.default = CarouselNoticebar;
//# sourceMappingURL=index.js.map